import type { ReactNode, SyntheticEvent } from 'react'

export enum ProductTileSize {
  small = 's',
  medium = 'm',
  large = 'l',
}

export interface ProductTileProps {
  imgAlt: string
  imgSrc: string
  size: ProductTileSize
  name: string
  price?: string
  originalPrice?: string
  value?: number
  tags?: ReactNode
  canAddToCart?: boolean
  showCounter?: boolean
  onAdd?: (e?: SyntheticEvent<HTMLButtonElement>) => void
  onRemove?: (e?: SyntheticEvent<HTMLButtonElement>) => void
  onClick: (e?: SyntheticEvent<HTMLDivElement>) => void
}
